// extracted by mini-css-extract-plugin
module.exports = {"Document":"Document_Document__1KqwB","Document__actions":"Document_Document__actions__3F5UH","Document__link":"Document_Document__link__Szhw_"};